<template>
  <div class="modal" :class="{ open_modal: showImageModal }">
    <div class="modal_overlay"></div>
    <div class="modal_inner max_height_80">
      <div class="modal_header">
        <span class="close_icon close_icon_sm" @click="closeImageModal()"
          >×</span
        >
        <h2>{{ $t('special_lecture.image') }}</h2>
      </div>
      <div class="modal_wrapper">
        <div class="modal_content modal_1080p">
          <div v-html="convertTextEditor(lectureImage.main_text)"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Mathml2latex from 'mathml-to-latex';
export default {
  name: 'lecture-image-modal',
  data() {
    return {};
  },
  props: {
    showImageModal: {
      type: Boolean,
      required: true,
    },
    lectureImage: {
      type: Object,
      required: true,
    },
  },
  created() {},
  updated() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
  },
  methods: {
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });
        return doc.body.innerHTML;
      } else {
        return string;
      }
    },
    getLatex(mathTag) {
      try {
        let latex = Mathml2latex.convert(mathTag);
        latex = this.sanitizeLatex(latex);
        latex = `\\[${latex}\\]`; // for block math
        return latex;
      } catch (error) {
        console.error('Latex conversion failed:', error);
        return mathTag; // fallback: keep original MathML
      }
    },
    sanitizeLatex(latex) {
      return latex
        .replace(/&nbsp;/g, ' ') // remove non-breaking spaces
        .replace(/\\left\\\(\\right\.\s*/g, '\\left(') // fix left paren
        .replace(/\s*\\left\.\s*\\right\\\)/g, '\\right)') // fix right paren
        .replace(/\s{2,}/g, ' ') // remove extra spaces
        .trim();
    },
    __getLatex(mathTag) {
      let latex = Mathml2latex.convert(mathTag);
      latex = '$$' + latex + '$$';
      latex = latex.replace(/\+\b/g, '\\\\');
      return latex;
    },
    closeImageModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style scoped>
.modal_inner .close_icon {
  position: absolute;
  top: -15px;
  right: -15px;
  overflow: hidden;
  cursor: pointer;
  z-index: 5;
  padding: 0.2rem 0.62rem;
  box-shadow: 0px 4px 24px 0px rgb(34 41 47 / 10%);
  border-radius: 4px;
  background: #fff;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1;
  transition: all 0.3s;
}
</style>
